import axios from "axios";
import { gateAuthStore } from "../stores/geteAuth";

const API_BASE = process.env.REACT_APP_API;
const GATE_USERNAME = process.env.REACT_APP_GATE_USERNAME;
const GATE_PASSWORD = process.env.REACT_APP_GATE_PASSWORD;
const API_KEY = process.env.REACT_APP_API_KEY;

const API_GATE_URL = `${API_BASE}/API/Authen`;

async function getGatewayToken() {
  const { token, isValid, set } = gateAuthStore.getState();

  if (isValid()) return token;

  const form = new URLSearchParams();
  form.append("USERNAME", GATE_USERNAME);
  form.append("PASSWORD", GATE_PASSWORD);

  const res = await axios.post(API_GATE_URL, form, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "x-api-key": API_KEY,
    },
    timeout: 15000,
  });

  if (String(res.data?.statustext).toUpperCase() !== "SUCCESS") {
    throw new Error(res.data?.message || "Get gateway token failed");
  }

  const newToken = res.data.token;
  const expiredMs = new Date(res.data.expired).getTime();
  set(newToken, expiredMs); // เก็บไว้ในหน่วยความจำ (ไม่ persist)
  return newToken;
}

// === axios instance กลางสำหรับทุก service ของ plomapi ===
export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

// แนบ Bearer <gateway_token> อัตโนมัติ
api.interceptors.request.use(async (config) => {
  const tk = await getGatewayToken();
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${tk}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err)
);